import React from "react";
import { FEATURES } from "../../../lib/landingContent";
import "./launch.css";

const LaunchSection: React.FC = () => {
  return (
    <section className="launch-section">
      <div className="launch-inner">
        <div className="launch-heading-wrap">
          <div className="launch-kicker">
            OUR WORKFLOW
          </div>
          <h1 className="launch-title" id="how-it-works">
           Everything you need to build and grow your brand.
          </h1>
        </div>

        <div className="launch-grid">
          {FEATURES.map((feature) => (
            <article className="launch-feature" key={feature.id}>
              
              <div className="launch-feature-content">
                <p className="launch-feature-title">{feature.title}</p>
                <p className="launch-feature-description">
                  {feature.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LaunchSection;
